// Host detection for Walter (walter.raisedbeef.com) — product 8, Agricultural
// Balance Sheets. See PRODUCTS.md.
//
// Walter is its own product with its own front door (owner, 2026-10-19:
// "Walter will be a separate product"). It shows USDA-published balance sheets
// only and never mixes with DVAuction lots or barn data — see
// src/pages/walter/walterNoDv.test.ts, which enforces that.
//
// Same stickiness as isFooteHost(), for the same reason: on a Vercel preview or
// localhost `?site=walter` is the only thing that makes these routes exist, and
// the first client-side navigation drops the query string. Remembered per tab.
// This decides which routes render, nothing else; who may READ is decided on
// the server (is_partner_member, src/lib/footeGate.ts).

export const WALTER_HOSTS = ["walter.raisedbeef.com"];

const PREVIEW_KEY = "rb.site.walter";

/** walter.raisedbeef.com. Local/dev preview: `?site=walter`. */
export function isWalterHost(): boolean {
  if (typeof window === "undefined") return false;
  if (WALTER_HOSTS.includes(window.location.hostname)) return true;
  try {
    if (new URLSearchParams(window.location.search).get("site") === "walter") {
      window.sessionStorage?.setItem(PREVIEW_KEY, "1");
      return true;
    }
    return window.sessionStorage?.getItem(PREVIEW_KEY) === "1";
  } catch {
    return false;
  }
}

/** The partner slug Walter seats are granted under (partner_members). Admins always pass. */
export const WALTER_PARTNER = "walter";

/**
 * What WALTER stands for (owner, 2026-10-19, picked from four). Shown on the
 * sign-in card, in the top bar and at the head of the menu. A balance sheet is
 * a ledger; trade, USDA's estimates and their revisions are what Walter tracks.
 */
export const WALTER_WORDS: [string, string][] = [
  ["W", "orld"], ["A", "gricultural"], ["L", "edger of"], ["T", "rade,"], ["E", "stimates &"], ["R", "evisions"],
];
export const WALTER_EXPANSION = "World Agricultural Ledger of Trade, Estimates & Revisions";

/** Where a signed-in Walter user lands. */
export const WALTER_HOME = "/walter/this-month"; // owner, 2026-10-19: "Opening = This month"
